import initApp from '../App/index';

/**
 * Инициализация выборщика.
 */
function main(): void
{
	initApp();
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/Index/index.tsx